const getPrescriberState = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber['Address Information']) {
    const address = prescriber['Address Information'];
    if (address.State) {
      return address.State.toUpperCase();
    }
    return null;
  }
  if (patient.Prescriber[0]) {
    const address = patient.Prescriber[0]['Address Information'];
    if (address.State) {
      return address.State.toUpperCase();
    }
    return null;
  }
  return null;
};

export default getPrescriberState;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberState.js